import React, { createContext, useContext, PropsWithChildren } from "react";
import { IAdvancedWidgetOptions } from "../models/IAdvancedWidgetOptions";

const Context = createContext<{ [key: string]: any } | undefined>(undefined);

export const useFormDataContext = () => useContext(Context);

interface FormDataProviderProps {
    data: { [key: string]: any };
}

export const FormDataProvider: React.FC<PropsWithChildren<FormDataProviderProps>> = ({ data, children }) => {
    return (
        <Context.Provider value={data}>
            {children}
        </Context.Provider>
    );
};